import { Popconfirm, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { MdOutlineAddIcCall } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { CiTrash } from "react-icons/ci";

import "../style.css"
import { useEffect } from "react";

const TabelaContatos = ({
  contatoCliente = [],
  isLoading,
  abrirModalEditar,
  removerContato,
  setIsModalAddNovoContato,
  cancel,
  formatTelefone
}) => {

  useEffect(()=> {
    console.log("contatoCliente", contatoCliente);
  }, [])
  return (
    <div className="ct-table-wrap">
      <div className="ct-header">
        <h2>Contatos</h2>
        <span className="ct-badge">{contatoCliente.length}</span>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
        <div className="ct-btn-add" onClick={() => setIsModalAddNovoContato(true)}>
          <MdOutlineAddIcCall />
        </div>
      </div>

      {isLoading ? (
        <div style={{ padding: 10, display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Spin indicator={<LoadingOutlined spin />} size="large" />
        </div>
      ) : (
        <div className="ct-table">
          <div className="ct-row ct-row-head">
            <div className="ct-col ct-col-name">Nome</div>
            <div className="ct-col ct-col-phone">Telefone</div>
            <div className="ct-col ct-col-email">Email</div>
            <div className="ct-col ct-col-actions" aria-hidden="true">Ações</div>
          </div>

          {contatoCliente.length > 0 ? (
            Array.isArray(contatoCliente) &&
            contatoCliente.map((c) => (
              <div className="ct-row" key={c.id}>
                <div className="ct-col ct-col-name">
                  <div className="ct-name-wrap">
                    <div className="ct-name">{c.nome}</div>
                  </div>
                </div>

                <div className="ct-col ct-col-phone">
                  <span className="ct-link">{formatTelefone(c.telefone) || "—"}</span>
                </div>

                <div className="ct-col ct-col-email">
                  <span className="ct-link">{c.email || "—"}</span>
                </div>

                <div className="ct-col ct-col-actions">
                  <div className="ct-btn ct-btn-edit" onClick={() => abrirModalEditar(c)}>
                    <FaRegEdit />
                  </div>

                  <Popconfirm
                    title="Remover contato"
                    description="Tem certeza que deseja remover este contato?"
                    onConfirm={() => removerContato(c.id)}
                    onCancel={cancel}
                    okText="Sim"
                    cancelText="Não"
                  >
                    <div className="ct-btn ct-btn-delete">
                      <CiTrash />
                    </div>
                  </Popconfirm>
                </div>
              </div>
            ))
          ) : (
            <div className="ct-empty">Nenhum contato encontrado.</div>
          )}
        </div>
      )}
    </div>
  );
};

export default TabelaContatos;
